import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import authReducer, { clearAuth } from "./reducers/auth/authSlice";
import userReducer from "./reducers/user/userSlice";
import productReducer from "./reducers/product/productSlice";
import jobReducer from "./reducers/job/jobSlice";
import jobCreatorReducer from "./reducers/jobCreator/jobCreatorSlice";
import spotlightReducer from "./reducers/spotlight/spotlightSlice";
import helpCenterReducer from "./reducers/helpCenter/helpCenterSlice";
import workReducer from "./reducers/work/workSlice";
import ratingReducer from "./reducers/rating/ratingSlice";
import chatReducer from "./reducers/chat/chatSlice";
import notificationReducer from "./reducers/notification/notificationSlice";

// Create the root reducer
const appReducer = combineReducers({
  auth: authReducer,
  user: userReducer,
  product: productReducer,
  job: jobReducer,
  jobCreator: jobCreatorReducer,
  spotlight: spotlightReducer,
  helpCenter: helpCenterReducer,
  work: workReducer,
  rating: ratingReducer,
  chat: chatReducer,
  notification: notificationReducer,
});

// Custom root reducer with reset functionality
const rootReducer = (state, action) => {
  if (action.type === clearAuth.type) {
    return {
      ...appReducer(undefined, action),
      product: state.product,
    };
  }

  return appReducer(state, action);
};
// Persist config
const persistConfig = {
  key: "root",
  storage,
  whitelist: [
    "auth",
    "user",
    "product",
    "job",
    "jobCreator",
    "spotlight",
    "helpCenter",
    "work",
    "rating",
    "chat",
    "notification",
  ],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// Store configuration
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          "persist/PERSIST",
          "persist/REHYDRATE",
          "auth/logout/fulfilled",
        ],
      },
    }),
});

export const persistor = persistStore(store);
